import React, { useState, useEffect } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Image, Link, OnVisible } from 'components';
import * as styles from './styles.module.scss';

const PartnerList = () => {
  const partnersQuery = graphql`
    query settingsQuery {
      prismicSettings {
        data {
          partners {
            comparison_rate
            interest_rate
            business_comparison_rate
            business_interest_rate
            personal_comparison_rate
            person_interest_rate
            lender
            logo {
              url
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED, width: 400, placeholder: NONE)
                }
              }
            }
          }
        }
      }
    }
  `;

  const data = useStaticQuery(partnersQuery);
  const { prismicSettings } = data;
  const { data: settingsData } = prismicSettings;
  const { partners } = settingsData;

  const [partnersToUse, setPartnersToUse] = useState(partners);
  const [logosVisible, setLogosVisible] = useState(false);

  // if not enough items to complete a row (- see all lenders tile)
  // then remove the incomplete row
  const remainder = partners.length % 6;
  const incompleteRow = remainder < 5;

  useEffect(() => {
    if (incompleteRow) {
      const clonedPartners = [...partners];
      clonedPartners.splice(-`${remainder}`, `${remainder}`);
      setPartnersToUse(clonedPartners);
    }
  }, []);

  function customSort(arr) {
    const includeUseRate = arr.map((lender) => {
      return {
        ...lender,
        useRate: lender.interest_rate || lender.business_interest_rate || lender.person_interest_rate,
      };
    });

    return includeUseRate.sort((a, b) => (a.useRate > b.useRate ? 1 : -1));
  }

  return (
    <div className={styles.PartnersList}>
      {customSort(partnersToUse).map((partner) => {
        const {
          interest_rate: interest,
          logo,
          text,
          url,
          lender,
          business_interest_rate: bizInterest,
          person_interest_rate: perInterest,
        } = partner;

        const interestToUse = interest || bizInterest || perInterest;
        return (
          <OnVisible className={styles.partner} key={logo?.url || text} onChange={setLogosVisible}>
            {logo?.url && logosVisible && (
              <Image className={styles.logo} image={logo} alt={lender} objectFit="contain" />
            )}
            {interestToUse && (
              <div>
                <span className={styles.interest}>Interest rates from:</span>
                <span className={styles.interest}>{interestToUse?.toFixed(2)}% p.a.</span>
              </div>
            )}
            {/* FINAL TILE */}
            {text && url && (
              <Link className={styles.lastTile} to={url}>
                {text}
              </Link>
            )}
          </OnVisible>
        );
      })}
      {partners.length % 6 === 5 && (
        <div className={styles.partner}>
          <Link className={styles.lastTile} to="/lenders/">
            See All Lenders
          </Link>
        </div>
      )}
    </div>
  );
};

export default PartnerList;
